import React from 'react';
import { compose, withHandlers } from 'recompose';
import withField from '../withField';
import Icon from 'components/Icon';

import styles from './styles.css';

const Item = withHandlers({
  onClick:
    ({ onClick, index }) =>
    () =>
      onClick(index),
})(({ icon, size, onClick, isActive }: any) => (
  <button onClick={onClick} disabled={isActive} className={styles.button}>
    <Icon
      name={icon}
      width={size || 10}
      height={size || 10}
      className={styles.icon}
    />
  </button>
));
export const IconsSelect = compose(
  withHandlers({
    onClick:
      ({ options, onChange }) =>
      (index) =>
        onChange(options[index].value),
  })
)(({ options, value, onClick }: any) => (
  <div className={styles.root}>
    {options.map((option, index) => (
      <Item
        key={index}
        index={index}
        onClick={onClick}
        isActive={value === option.value}
        {...option}
      />
    ))}
  </div>
));

export default withField(IconsSelect);
